import { useTranslation } from "react-i18next";

const PPandTOU = () => {
  const { t } = useTranslation();
  return (
    <div className="my-4 text-center">
      <p className="font-sans font-light text-xs text-brandGray2">
        {t("signUp.agreeTerms.prefix")}&nbsp;
        <a
          href="/privacyPolicy"
          target="_blank"
          rel="noreferrer"
          className="text-black underline cursor-pointer">
          {t("signUp.agreeTerms.privacy")}
        </a>
        &nbsp;{t("signUp.agreeTerms.and")}&nbsp;
        <a
          href="/terms-of-use"
          target="_blank"
          rel="noreferrer"
          className="text-black underline cursor-pointer">
          {t("signUp.agreeTerms.terms")}
        </a>
      </p>
    </div>
  );
};

export default PPandTOU;
